import React from 'react'
import { useState } from 'react'
import './styles.css' // Import the CSS file for styling
import FixWidthContainer from '../../atoms/fixWidthContainer'
import Spacer from '../../atoms/Spacer'
import who_am_I from '../../../assets/img/who_am_I.png'
import borboleta1 from '../../../assets/img/borboleta_1.png'
import CommonButton from '../../atoms/CommonButton'

const WhoAmI = () => {
  const [isMobile, setIsMobile] = React.useState(false)
  const [isExpanded, setIsExpanded] = useState(false)

  const toggleExpand = () => {
    setIsExpanded(!isExpanded)
  }

  return (
    <div>
      {isMobile ? (
        <div>
          <FixWidthContainer>
            <section className="whoami-container">
              <p className="whoami-text">
              <h2>Prazer, sou Gabriela Pinheiro</h2>
                <br />
                irmã mais velha em uma casa de 4 filhos, casada e mãe de duas crianças. Em 2015 me formei em Medicina pela Universidade Federal em Minas Gerais e em 2016 iniciei minha formação em Pediatria no Hospital das Clinicas da UFMG.
                <br/>
              <br />
              <span onClick={toggleExpand} className="read-more-btn">
                {isExpanded ? 'Mostrar menos' : 'Continuar lendo'}
              </span>
                {isExpanded && (
                  <>
                  <br />
                    <br />
                    Pediatra, em constante formação e
              transformação. Atualmente me dedico ao atendimento em consultório
              pediátrico e trabalho no setor de internação do{' '}
              Hospital Mater Dei. Possuo formação complementar
              em Consultoria de Amamentação,
               Insônia em Pediatria,{' '}
              Introdução Alimentar Participativa e
               Cuidados Paliativos Pediátricos. Em{' '}
              2023, conclui o Mestrado, também na{' '}
              Universidade Federal de Minas Gerais, com foco no
                    estudo do desenvolvimento infantil.
                    
                  <br />
                  <br />
                  Para além da experiência acadêmica, considero que a{' '}
                  maternidade 
                  foi um grande transformador em minha prática. Ter vivido o{' '}
                  puerpério, privação de sono, convívio com
                    “opiniões”, amamentação, sono, choro,
                    birras, introdução escolar e tantos outros desafios
                  do cuidar me fez amadurecer como pessoa e como pediatra. A
                  primeira vivência da maternidade me desafiou; a segunda me fez
                  ter certeza absoluta de que não existem limites para os
                  desafios que encontraremos nessa jornada… como também não
                  existe amor maior, nem recompensa mais incrível do que
                  perceber toda nossa dedicação refletida no sorriso de uma
                  criança em desenvolvimento.
                  <br />
                  <br />
                  Tempo adequado para escuta durante as
                  consultas, disponibilidade para agendamentos de urgências e
                  disponibilidade para contato fora do consultório são os
                  principais diferenciais que busco garantir
                  aos meus pacientes. Entendo que é essencial ser acessível e
                  conhecer profundamente meus pacientes e suas famílias para
                  garantir um atendimento médico verdadeiramente{' '}
                  humanizado e individualizado.
                  <br />
                  <br />
                  <span onClick={toggleExpand} className="read-more-btn">
                    {isExpanded ? 'Mostrar menos' : 'Continuar lendo'}
                  </span>
                </>
                )}
              </p>
              <hr style={{ marginTop: 0 }} className="divider-line" />
            </section>
          </FixWidthContainer>
          <Spacer size={100} />
        </div>
      ) : (
        <FixWidthContainer>
          <section className="whoami-container">
            <p className="whoami-text">
                <h2>Prazer, sou Gabriela Pinheiro</h2>
                <br />
                irmã mais velha em uma casa de 4 filhos, casada e mãe de duas crianças. Em 2015 me formei em Medicina pela Universidade Federal em Minas Gerais e em 2016 iniciei minha formação em Pediatria no Hospital das Clinicas da UFMG.
                <br/>
              <br />
              <span onClick={toggleExpand} className="read-more-btn">
                {isExpanded ? 'Mostrar menos' : 'Continuar lendo'}
              </span>
              {isExpanded && (
                <>
                  <br />
                    <br />
                    Pediatra, em constante formação e
              transformação. Atualmente me dedico ao atendimento em consultório
              pediátrico e trabalho no setor de internação do{' '}
              Hospital Mater Dei. Possuo formação complementar
              em Consultoria de Amamentação,
               Insônia em Pediatria,{' '}
              Introdução Alimentar Participativa e
               Cuidados Paliativos Pediátricos. Em{' '}
              2023, conclui o Mestrado, também na{' '}
              Universidade Federal de Minas Gerais, com foco no
                    estudo do desenvolvimento infantil.
                    
                  <br />
                  <br />
                  Para além da experiência acadêmica, considero que a{' '}
                  maternidade 
                  foi um grande transformador em minha prática. Ter vivido o{' '}
                  puerpério, privação de sono, convívio com
                    “opiniões”, amamentação, sono, choro,
                    birras, introdução escolar e tantos outros desafios
                  do cuidar me fez amadurecer como pessoa e como pediatra. A
                  primeira vivência da maternidade me desafiou; a segunda me fez
                  ter certeza absoluta de que não existem limites para os
                  desafios que encontraremos nessa jornada… como também não
                  existe amor maior, nem recompensa mais incrível do que
                  perceber toda nossa dedicação refletida no sorriso de uma
                  criança em desenvolvimento.
                  <br />
                  <br />
                  Tempo adequado para escuta durante as
                  consultas, disponibilidade para agendamentos de urgências e
                  disponibilidade para contato fora do consultório são os
                  principais diferenciais que busco garantir
                  aos meus pacientes. Entendo que é essencial ser acessível e
                  conhecer profundamente meus pacientes e suas famílias para
                  garantir um atendimento médico verdadeiramente{' '}
                  humanizado e individualizado.
                  <br />
                  <br />
                  <span onClick={toggleExpand} className="read-more-btn">
                    {isExpanded ? 'Mostrar menos' : 'Continuar lendo'}
                  </span>
                </>
              )}
            </p>
            <hr style={{ marginTop: 0 }} className="divider-line" />
          </section>
        </FixWidthContainer>
      )}
    </div>
  )
}

export default WhoAmI
